import { ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import React, { ReactNode } from "react";



interface NaviItemProps {
    onClick?: React.MouseEventHandler<HTMLDivElement>,
    text?: string,
    icon?: ReactNode,
    children?: ReactNode
}

const NaviItem: React.FC<NaviItemProps> = ({
    onClick,
    text,
    icon,
    children,
}) => {
    return (
        <ListItemButton
            onClick={onClick ? onClick : undefined}
        >
            {icon &&
                <ListItemIcon>{icon}</ListItemIcon>
            }
            {text &&
                <ListItemText primary={text} />
            }
            {children}
        </ListItemButton>
    );
}

export default NaviItem